import { useEffect, useRef, useState } from 'react';

import { isDogfoodPerfHUDEnabled } from './isEnabled';

export const useIsDogfoodPerfHUDEnabled = () => {
  const [isEnabled, setIsEnabled] = useState(false);
  const isMounted = useRef(true);

  useEffect(() => {
    const getExperimentState = async () => {
      const result = await isDogfoodPerfHUDEnabled();
      // istanbul ignore else
      if (isMounted.current) {
        setIsEnabled(result);
      }
    };
    getExperimentState();

    return () => {
      isMounted.current = false;
    };
  }, []);

  return isEnabled;
};
